<template>
  <footer class="footer">
    <div class="copyright">
      {{ copyright }}
    </div>
  </footer>
</template>
<script setup lang="ts">
import moment from 'moment';
import { computed } from 'vue';

const copyright = computed(() => `Copyright © AUMOVIO Digital Services France ${moment().format('YYYY')}`);

</script>
<style lang="scss" scoped>
@import './styles/application-footer.scss';
</style>
